import { useQuery } from 'react-query';
import { queryAllBoostsInvoices } from './useBoostsInvoices.query';
import { CommissionInvoice } from '../../../types/models/commission/commission.types';

export const ALL_BOOSTS_INVOICES_QUERY_KEY = 'ALL_BOOSTS_INVOICES';

export const useBoostsInvoices = () => {
  return useQuery<CommissionInvoice[], Error>(ALL_BOOSTS_INVOICES_QUERY_KEY, () =>
    queryAllBoostsInvoices()
  );
};
